var Soundmanager = require('./soundmanager2.js');

var audio = require('./modules/audio/');

  var soundmanager = new Soundmanager();

  var index = 0;

  soundmanager.setup({
    useConsole: false,
    debugMode: false
  });
  soundmanager.useConsole = false;

 soundmanager.html5Only = true;


  var activeSound = null;

  var LiveAudio = function(options){
    this.init(options);
  };

  LiveAudio.prototype.init = function(options) {
    this.options = options;
     this.id = options.audio_id;
     this.url = options.audio_url;

      this.resolveTemplate();
     
      this.bindDomEvent();

  };


    // 创建并解析模板
    LiveAudio.prototype.resolveTemplate = function () {
      // 以jquery为例
      // 使用模板
     
      this.options.index = index;

      index++;
       
      var audioHtml = audio(this.options);
        this.el = document.createElement('div');
      $(this.el).append(audioHtml);
      this.ownerNode = $(this.el).find('.liveaudio_container');
    };

    // 绑定dom事件
    LiveAudio.prototype.bindDomEvent = function () {
      // 以jquery为例
      var _this = this;

      $(this.ownerNode).on('click', function (e) {
        _this.play();
      });
    };
    

    // 渲染组件。
   

    LiveAudio.prototype.play = function () {
      var _this = this;
      if (!this.sound) {
        this.sound = soundmanager.createSound({
          id: this.id,
          url: this.url,
          onplay: function () {
            _this.onplay();
          },
          onstop: function () {
            _this.onstop()
          },
          onpause: function () {
            _this.onpause()
          },
          onresume: function () {
            _this.onresume();
            this.setPosition(0);
          },
          onfinish: function () {
            _this.onfinish()
          }
        });
      }
      if (activeSound && activeSound != this.sound) {
        activeSound.pause();
      }
      activeSound = this.sound;
      if (this.sound.playState == 0) {
        this.sound.play();
      } else if (!this.sound.paused) {
        this.sound.pause();
      } else {
        this.sound.play();
      }
    };

    LiveAudio.prototype.onplay = function () {
      this.ownerNode.addClass('liveaudio_play');
    };

    LiveAudio.prototype.onstop = function () {
      this.ownerNode.removeClass('liveaudio_play');
    };

    LiveAudio.prototype.onpause = function () {
      this.ownerNode.removeClass('liveaudio_play');
    };

    LiveAudio.prototype.onresume = function () {
      this.ownerNode.addClass('liveaudio_play');
    };

    LiveAudio.prototype.onfinish = function () {
      this.ownerNode.removeClass('liveaudio_play');
    };

    LiveAudio.prototype.renderTo = function (parentNode) {
        parentNode.appendChild($(this.el).children()[0]);
    };

  module.exports = LiveAudio;



// WEBPACK FOOTER //
// /Users/zhujian/Desktop/code/live_system/live/modules/f.component.audio.pc/app/index.js